/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData();

            if (data.hasOwnProperty('slotColor')) {
                obj['slotColor'] = ApiClient.convertToType(data['slotColor'], 'String');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['slotColor'] && !(typeof data['slotColor'] === 'string' || data['slotColor'] instanceof String)) {
            throw new Error("Expected the field `slotColor` to be a primitive type in the JSON string but got " + data['slotColor']);
        }
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {String} slotColor
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData.prototype['slotColor'] = undefined;

/**
 * @member {String} itemName
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData.prototype['itemName'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventoryCarGemData;

